/* @flow */
import liferay from '../../services/api';

import type {
  Action,
  AsyncAction,
  Usage,
  FindUsageParams,
  SaveUsageParams,
} from '../../types/index';

const onFailure = (error: Object) => console.warn(error);

const fetchUsageList = (params?: FindUsageParams): AsyncAction => {
  return {
    type: 'FETCH_USAGE_LIST_REQUEST',
    payload: params,
    promise: liferay.usages.find(params),
    meta: { onFailure },
  };
};

const fetchUsage = (id: number): AsyncAction => {
  return {
    type: 'FETCH_USAGE_REQUEST',
    payload: id,
    promise: liferay.usages.get(id),
    meta: { onFailure },
  };
};

const createUsage = (): Action => {
  return {
    type: 'CREATE_USAGE',
    meta: { onFailure },
  };
};

const saveUsage = (params: SaveUsageParams, onSuccess?: (usage: Usage) => any): AsyncAction => {
  // $FlowFixMe
  const promise: Promise<Usage> = params.id
    ? //$FlowFixMe
      liferay.usages.update(params)
    : liferay.usages.create(params);
  return {
    type: 'SAVE_USAGE_REQUEST',
    promise,
    meta: { onFailure, onSuccess },
  };
};

const deleteUsage = (id: number, onSuccess?: (id: number) => any): AsyncAction => {
  return {
    type: 'DELETE_USAGE_REQUEST',
    payload: id,
    promise: liferay.usages.delete(id),
    meta: { onFailure, onSuccess },
  };
};

const setSessionUsageId = (id?: number): Action => {
  try {
    return {
      type: 'SET_SESSION_USAGE_ID_SUCCESS',
      payload: liferay.usages.session.setId(id),
    };
  } catch (error) {
    return {
      type: 'SET_SESSION_USAGE_ID_FAILURE',
      payload: error,
    };
  }
};

const getSessionUsageId = (): Action => {
  try {
    return {
      type: 'GET_SESSION_USAGE_ID_SUCCESS',
      payload: liferay.usages.session.getId(),
    };
  } catch (error) {
    return {
      type: 'GET_SESSION_USAGE_ID_FAILURE',
      payload: error,
    };
  }
};

export default {
  fetchUsageList,
  fetchUsage,
  createUsage,
  saveUsage,
  deleteUsage,
  setSessionUsageId,
  getSessionUsageId,
};
